if (!customElements.get('swym-favourites-list')) {
  customElements.define(
    'swym-favourites-list',
    class SwymFavouritesList extends HTMLElement {
      constructor() {
        super();

        this.container = document.querySelector('.favourites');

        this.copyListButton = document.querySelector('[data-copy-link]');

        if (this.copyListButton) {
          this.copyListButton.addEventListener(
            'click',
            this.copyListLink.bind(this)
          );
        }

        if (!window.SwymCallbacks) {
          window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(this.init.bind(this));
      }

      init(swat) {
        this.swat = swat;

        const hkey = new URL(window.location.href).searchParams.get('hkey');

        if (hkey) {
          this.getSharedFavourites(hkey);
        } else {
          this.getFavourites();
        }

        this.swat.evtLayer.addEventListener(
          this.swat.JSEvents.removedFromWishlist,
          function (e) {
            const variantCard = document.querySelector(
              '.card[data-variant-id="' + e.detail.d.epi + '"]'
            );
            if (variantCard) {
              variantCard.parentElement.remove();
            } else {
              const card = document.querySelector(
                '.card[data-id="' + e.detail.d.empi + '"]'
              );
              card.parentElement.remove();
            }
          }
        );
      }

      copyListLink(event) {
        event.preventDefault();
        event.target.innerHTML = 'Copied!';
        const link = document.querySelector('[data-link]').value;

        navigator.clipboard.writeText(link);
      }

      getFavourites() {
        const self = this;

        window._swat.fetch(
          function (products) {
            if (products.length > 0) {
              const promises = [];

              products.forEach((product) => {
                promises.push(
                  new Promise((resolve, reject) => {
                    fetch(
                      `${product.du}?variant=${product.epi}&section_id=card_swym`
                    )
                      .then((response) => response.text())
                      .then((responseText) => {
                        const html = new DOMParser().parseFromString(
                          responseText,
                          'text/html'
                        );

                        const card = html.querySelector('.card');
                        resolve(card);
                      });
                  })
                );
              });

              Promise.all(promises).then((cards) => {
                cards.forEach((card) => {
                  const li = document.createElement('li');
                  li.classList.add('grid__item');
                  li.appendChild(card);

                  const container = document.querySelector(
                    'swym-favourites-list'
                  );
                  container.appendChild(li);
                });

                document.dispatchEvent(
                  new CustomEvent('swym:collections-loaded')
                );
              });
            } else {
              self.generateEmptyState(true);
            }
          },
          function (err) {
            console.error('Unable to fetch wishlist', err);
            self.generateEmptyState(true);
          }.bind(this)
        );

        window._swat.generateSharedListURL(null, function (data, sharedListId) {
          document.querySelector('[data-link]').value = data;
        });
      }

      getSharedFavourites(hkey) {
        const emptyState = this.generateEmptyState();

        _swat.fetchListDetails(
          { lid: hkey },
          function (products) {
            if (products.items.length > 0) {
              const promises = [];

              products.items.forEach((product) => {
                promises.push(
                  new Promise((resolve, reject) => {
                    fetch(
                      `${product.du}?variant=${product.epi}&section_id=card_swym`
                    )
                      .then((response) => response.text())
                      .then((responseText) => {
                        const html = new DOMParser().parseFromString(
                          responseText,
                          'text/html'
                        );

                        const card = html.querySelector('.card');
                        resolve(card);
                      });
                  })
                );
              });

              Promise.all(promises).then((cards) => {
                cards.forEach((card) => {
                  const li = document.createElement('li');
                  li.classList.add('grid__item');
                  li.appendChild(card);

                  const container = document.querySelector(
                    'swym-favourites-list'
                  );
                  container.appendChild(li);
                });

                document.dispatchEvent(
                  new CustomEvent('swym:collections-loaded')
                );
              });
            } else {
              emptyState(true);
            }
          },
          function (err) {
            console.error('Unable to fetch wishlist', err);
            emptyState(true);
          }
        );
      }

      generateEmptyState(append = false) {
        const emptyState = document.createElement('div');
        emptyState.classList.add('favourites__empty');
        emptyState.innerHTML = `
          <div class="favourites__message">
            ${window.swym.empty_message}
          </div>
          <div class="favourites__account">
            ${
              window.theme.customer.id == ''
                ? `<a href="${window.routes.account_login_url}" class="button">${window.swym.sign_in_to_save}</a>`
                : ``
            }
            <a href="/collections/new-arrivals-1" class="button button--secondary">${window.swym.start_shopping}</a>               
          </div>
        `;

        this.container.classList.add('favourites--empty');

        if (append) {
          this.appendChild(emptyState);
        }
      }
    }
  );
}
